import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-inetfa2',
  templateUrl: './inetfa2.component.html',
  styleUrls: ['./inetfa2.component.scss']
})
export class Inetfa2Component implements OnInit {

  exposition: CardContent = {
    title: 'iNET-FA2',
    subtitle: 'Intelligente Verteilnetze',
    image_source: 'assets/images/iNET-FA2.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients / Partners</h4>Fachhochschule Südwestfalen, BMFT',
      '<h4>Methods</h4>Web-Application Development',
      '<h4>Technology / Skills</h4>Javascript, Angular, InfluxDB, ArangoDB',
      '<h4>Term</h4>2015 - 2017',
      '<h4>Explore the App</h4><a href="http://power.exploratory-systems.de">power.exploratory-systems.de</a>'
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
